import React, { useState } from "react";

const Security = () => {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showTwoFactorAuth, setShowTwoFactorAuth] = useState(false);
  const [showActiveSessions, setShowActiveSessions] = useState(false);

  const handleResetPasswordClick = () => {
    setShowResetPassword(!showResetPassword);
  };

  const handleTwoFactorAuthClick = () => {
    setShowTwoFactorAuth(!showTwoFactorAuth);
  };

  const handleActiveSessionsClick = () => {
    setShowActiveSessions(!showActiveSessions);
  };

  const handleDeleteAccountClick = () => {
    // code to delete the account
  };

  return (
    <div>
      <h2 className="font-bold text-gray-700 text-lg mb-2">Security</h2>

      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-lg mb-2">Password</h3>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={handleResetPasswordClick}
        >
          Reset
        </button>
        {showResetPassword && (
          <div className="mt-2">
            {/* code to reset password */}
          </div>
        )}
      </div>

      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-lg mb-2">
          Two-factor authentication
        </h3>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={handleTwoFactorAuthClick}
        >
          Set up
        </button>
        {showTwoFactorAuth && (
          <div className="mt-2">
            {/* code to set up two-factor authentication */}
          </div>
        )}
      </div>

      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-lg mb-2">Active sessions</h3>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={handleActiveSessionsClick}
        >
          View
        </button>
        {showActiveSessions && (
          <div className="mt-2">
            {/* code to view active sessions */}
          </div>
        )}
      </div>

      <div className="mb-4">
        <h3 className="font-bold text-gray-700 text-lg mb-2">Delete account</h3>
        <button
          className="text-red-500 hover:text-red-700 text-sm"
          onClick={handleDeleteAccountClick}
        >
          Delete account
        </button>
      </div>
    </div>
  );
};

export default Security;
